
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/allied-services/[slug]",
      function () {
        return require("private-next-pages/student-services/allied-services/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-services/allied-services/[slug]"])
      });
    }
  